import { Col, Row } from 'react-dsgov';
import styles from './operacaoRepasseFormReadOnly.module.scss';
import { IRepasseParceiro } from '../../../../../../../../../interfaces/IBaseDeCalculo';
import {
  DocumentoVinculadoDetalhe,
  EDocumentoVinculado,
  ETipoVinculo,
  ETransportador,
} from '../../../../../../../../../enums/ERepasseParceiro';
import { formatarCNPJOrCpf } from '../../../../../../../../../utils/formatCNPJOrCPF';

interface ITitularArrendatarioOperacaoRepasseFormReadOnlyProps {
  repasseParceiro: IRepasseParceiro | undefined;
}

const OperacaoRepasseFormReadOnly: React.FC<ITitularArrendatarioOperacaoRepasseFormReadOnlyProps> = ({
  repasseParceiro,
}) => {
  return (
    <div className={styles.container}>
      <Row className={styles.row}>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Tipo de Vínculo </span>
          <span className={styles.dadoAdicionado}>
            {ETipoVinculo[repasseParceiro?.tipoVinculo as keyof typeof ETipoVinculo]}
          </span>
        </Col>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Descrição do Vínculo</span>
          <span className={styles.dadoAdicionado}>{repasseParceiro?.descricaoVinculo}</span>
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>CPF/CNPJ</span>
          <span className={styles.dadoAdicionado}>{formatarCNPJOrCpf(repasseParceiro?.cpfCnpj || '')}</span>
        </Col>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Nome/Razão Social</span>
          <span className={styles.dadoAdicionado}>{repasseParceiro?.nomeRazaoSocial}</span>
        </Col>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Endereço</span>
          <span className={styles.dadoAdicionado}>{repasseParceiro?.endereco}</span>
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Documentos Vinculados à Operação:</span>
          {repasseParceiro?.documentosVinculados?.length && repasseParceiro?.documentosVinculados?.length > 0 && (
            <div className={styles.documentosVinculados}>
              {repasseParceiro?.documentosVinculados.map((documentoVinculado, index) => (
                <li key={index}>
                  {
                    DocumentoVinculadoDetalhe[
                      EDocumentoVinculado[documentoVinculado as keyof typeof EDocumentoVinculado]
                    ]?.label
                  }
                  {documentoVinculado === 'OUTROS' ? ` : ${repasseParceiro?.documentosVinculadosDescricao}` : ''}
                </li>
              ))}
            </div>
          )}
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Transportador</span>
          <span className={styles.dadoAdicionado}>
            {ETransportador[repasseParceiro?.transportador as keyof typeof ETransportador]}
          </span>
        </Col>
      </Row>
      {repasseParceiro?.transportador &&
        ETransportador[repasseParceiro.transportador as keyof typeof ETransportador] === ETransportador.TERCEIROS && (
          <>
            <Row className={styles.row}>
              <Col className={styles.dadosCol}>
                <span className={styles.label}>CPF/CNPJ</span>
                <span className={styles.dadoAdicionado}>
                  {repasseParceiro?.cpfCnpjTransportador ? formatarCNPJOrCpf(repasseParceiro.cpfCnpjTransportador) : ''}
                </span>
              </Col>
              <Col className={styles.dadosCol}>
                <span className={styles.label}>Nome/Razão Social</span>
                <span className={styles.dadoAdicionado}>{repasseParceiro?.nomeRazaoSocialTransportador}</span>
              </Col>
            </Row>
            <Row className={styles.row}>
              <Col className={styles.dadosCol}>
                <span className={styles.label}>Endereço</span>
                <span className={styles.dadoAdicionado}>{repasseParceiro?.enderecoTransportador}</span>
              </Col>
            </Row>
          </>
        )}
      <Row className={styles.row}>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Local de Entrega do Repasse</span>
          <span className={styles.dadoAdicionado}>{repasseParceiro?.localEntrega}</span>
        </Col>
      </Row>
    </div>
  );
};

export default OperacaoRepasseFormReadOnly;
